<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">IAB · Anlagenmodell</p>

      <h2 class="presentation-page__title">Das e way IAB-PV-Anlagenmodell</h2>

      <p class="presentation-page__text">
        Drei Stufen — rechtlich gesichert, technisch durchgeplant, finanziell strukturiert.
      </p>

      <div class="presentation-page__group-cards">
        <article v-for="step in steps" :key="step.number" class="presentation-page__group-card">
          <div
            :class="[
              'presentation-page__group-card-header',
              `presentation-page__group-card-header--${step.accent}`,
            ]"
          >
            Schritt {{ step.number }}
          </div>

          <div class="presentation-page__group-card-body presentation-page__group-card-body--step">
            <p
              :class="[
                'presentation-page__group-card-step-number',
                `presentation-page__group-card-step-number--${step.numberAccent}`,
              ]"
            >
              {{ step.numberLabel }}
            </p>
            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>
            <h3 class="presentation-page__group-card-title">{{ step.title }}</h3>
            <p class="presentation-page__group-card-text">{{ step.text }}</p>
          </div>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage30',

  components: { PrintPageLandscape, PresentationPage },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      steps: [
        {
          number: 1,
          accent: 'brand-primary',
          numberAccent: 'brand-primary',
          numberLabel: '01',
          title: 'Zugang zu fertig entwickelten Projekten',
          text:
            'e way verfügt über eine Vielzahl bereits ausentwickelter PV-Projekte mit gesicherten Dach- und Grundstücksrechten — sofort einsatzfähig für IAB-Investitionen.',
        },
        {
          number: 2,
          accent: 'brand-secondary',
          numberAccent: 'brand-secondary',
          numberLabel: '02',
          title: 'Rechtlicher Prüfungsprozess',
          text:
            'Alle PV-Projekte durchlaufen einen standardisierten Überprüfungsprozess, um die rechtliche Sicherheit der IAB-Strukturierung zu gewährleisten — Vertragsprüfung, steuerrechtliche Würdigung, Compliance.',
        },
        {
          number: 3,
          accent: 'brand-teal',
          numberAccent: 'brand-teal',
          numberLabel: '03',
          title: 'Technische Detailplanung nach IAB-Vorgabe',
          text:
            'Die Anzahl und Teilgrößendefinition der Anlagen wird so geplant, dass die IABs maximal genutzt werden können — physisch getrennte Teilbereiche, jeweils als eigene Wirtschaftseinheit dokumentiert.',
        },
      ],
    };
  },
};
</script>
